import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaChevronDown } from "react-icons/fa";
import Logo from "../assets/images/rabta logo.png";
import { AiOutlineInfoCircle } from 'react-icons/ai';

const maskFirstSeven = (mobileNumber) => {
  if (!mobileNumber || mobileNumber.length < 10) return mobileNumber;

  return "xxxxxxx" + mobileNumber.slice(-3);
};

export default function RetailerDashboard() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [retailer, setRetailer] = useState(null);
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(true);
  const [allEntries, setAllEntries] = useState([]);
  const [unredeemedCashgrams, setUnredeemedCashgrams] = useState([]);
  const [overallRank, setOverallRank] = useState(null);
  const [prevWeekData, setPrevWeekData] = useState(null);

  const [showAdjustmentPopup, setShowAdjustmentPopup] = useState(false);

  const lastEntry = allEntries[allEntries.length - 1];
  const weeklyEntries = (lastEntry?.week1Entries || 0) + (lastEntry?.week2Entries || 0);
  const top250Week2PendingAmount = lastEntry?.top250Week2PendingAmount || 0;
  const adjustmentEntries = weeklyEntries;
  const hasAdjustments = weeklyEntries > 0 || top250Week2PendingAmount > 0;
  const hasWeeklyEntries = weeklyEntries > 0;
  const week1Entries = lastEntry?.week1Entries || 0;
  const week2Entries = lastEntry?.week2Entries || 0;
  const week1Amount = week1Entries * 5; // ₹5 per entry
  const week2Amount = week2Entries * 5;
  const totalAdjustmentAmount = week1Amount + week2Amount + top250Week2PendingAmount;


  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  useEffect(() => {
    const stored = localStorage.getItem("retailer");
    if (!stored) {
      navigate("/retailers/login");
      return;
    }

    const user = JSON.parse(stored);

    Promise.all([
      fetch(`${process.env.REACT_APP_API_URL}retailers/${user.mobileNumber}`).then((res) =>
        res.json()
      ),
      fetch(`${process.env.REACT_APP_API_URL}retailers/leaderboard`).then((res) => res.json()),
    ])
      .then(([retailerRes, leaderboardRes]) => {
        if (retailerRes.status === "success") {
          setRetailer({ ...user, ...retailerRes.data });
        }

        if (leaderboardRes.status === "success" && leaderboardRes.data) {
          setLeaderboard(leaderboardRes.data);
        }
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  useEffect(() => {
    const stored = localStorage.getItem("retailer");
    if (!stored) {
      navigate("/retailers/login");
      return;
    }

    const user = JSON.parse(stored);

    fetch(`${process.env.REACT_APP_API_URL}retailers/cashgram/history/${user._id}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setAllEntries(data?.data || []);
        }
      });

    fetch(`${process.env.REACT_APP_API_URL}retailers/${user._id}/previous-week`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setPrevWeekData(data?.data || []);
        }
      });

  }, [navigate]);



  useEffect(() => {
    const unredeemed = allEntries?.filter(
      (entry) =>
        !entry.cashgramLink ||
        (entry.cashgramStatus && entry.cashgramStatus !== "CASHGRAM_REDEEMED")
    );

    setUnredeemedCashgrams(unredeemed);
  }, [allEntries]);

  useEffect(() => {
    const stored = localStorage.getItem("retailer");
    if (!stored) {
      navigate("/retailers/login");
      return;
    }

    const user = JSON.parse(stored);

    fetch(`${process.env.REACT_APP_API_URL}retailers/${user.mobileNumber}/overall-rank`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setOverallRank(data.data.overallRank);
        }
      })
      .catch((err) => console.error("Error fetching overall rank:", err));
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("retailer");
    navigate("/retailers/login");
  };

  if (loading) {
    return (
      <div className="dashboard-container">
        <img src={Logo} alt="logo" className="logo-main" />
        <div className="loader">{t("retailer.loading")}</div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="content-wrap">
        <img src={Logo} alt="logo" className="logo-main" />

        {retailer && (
          <div className="retailer-info">
            <div>
              <h1>
                {t("retailer.retailerCode")}:{" "}
                <strong>{retailer.retailerCode || retailer.code}</strong>
              </h1>
            </div>
            <div>
              {t("retailer.retailerName")}: <strong> {retailer.fullName}</strong>
            </div>
            <div>
              {t("retailer.mobile")}: <strong>+91-{retailer.mobileNumber}</strong>
            </div>
            <button className="logoutBtn" onClick={handleLogout}>
              {t("retailer.logout")}
            </button>
          </div>
        )}

        <div className="stats" style={{ marginBottom: "20px" }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            width: '100%'
          }}>
            {/* Main Stats Row */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: '1fr',
              gap: '12px',
              width: '100%'
            }}>
              {/* Current Week - First Box */}
              {/* <div className="card rank-card">
                <div style={{
                  fontSize: '14px',
                  fontWeight: 'bold',
                  marginBottom: '12px',
                  textAlign: 'center',
                  padding: '6px',
                  borderRadius: '8px',
                }}>
                  Current
                </div>
                <div className="rank-values">
                  <div className="rank-section">
                    <p className="rank-label">{t("retailer.rank")}</p>
                    <h2 className="rank-number">{retailer.currentRank || "--"}</h2>
                  </div>
                  <div className="divider"></div>
                  <div className="rank-section">
                    <p className="rank-label">{t("retailer.entries")}</p>
                    <h2 className="rank-number">{retailer.entriesThisWeek || "0"}</h2>
                  </div>
                </div>
              </div> */}

              {/* Overall - Second Box */}
              <div className="card rank-card">
                <div style={{
                  fontSize: '14px',
                  fontWeight: 'bold',
                  marginBottom: '12px',
                  textAlign: 'center',
                  padding: '6px',
                  borderRadius: '8px',
                }}>
                  Overall
                </div>
                <div className="rank-values">
                  <div className="rank-section">
                    <p className="rank-label">{t("retailer.rank")}</p>
                    <h2 className="rank-number">{overallRank || "--"}</h2>
                  </div>
                  <div className="divider"></div>
                  <div className="rank-section">
                    <p className="rank-label">{t("retailer.entries")}</p>
                    <h2 className="rank-number">{retailer.totalEntries || "0"}</h2>
                  </div>
                </div>
              </div>
            </div>

            {/* Previous Week Dropdown */}
            {prevWeekData && (
              <div className="card rank-card">
                <div style={{
                  fontSize: '14px',
                  fontWeight: 'bold',
                  marginBottom: '12px',
                  textAlign: 'center',
                  padding: '6px',
                  borderRadius: '8px',
                }}>
                  Current
                </div>
                  <div className="rank-values">
                    <div className="rank-section">
                      <p className="rank-label">Rank <br />&nbsp;</p>
                      <h2 className="rank-number">{prevWeekData?.rank || "--"}</h2>
                    </div>
                    <div className="divider"></div>
                    <div className="rank-section">
                      <p className="rank-label">Entries <br />&nbsp;</p>
                      <h2 className="rank-number">{prevWeekData?.entries || "0"}</h2>
                    </div>

                    {hasAdjustments && (
                      <>
                        <div className="divider"></div>
                        <div className="rank-section" style={{ position: 'relative' }}>
                          <p className="rank-label" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
                            <>
                              Adjustment <br />
                              {hasWeeklyEntries ? 'Entries' : 'Top 250 Amount'}
                            </>
                            {hasWeeklyEntries ? (
                              <AiOutlineInfoCircle
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setShowAdjustmentPopup(true);
                                }}
                                style={{
                                  cursor: 'pointer',
                                  fontSize: '16px',
                                  marginLeft: '4px'
                                }}
                              />
                              ): null}
                          </p>
                          <h2 className="rank-number">
                            {hasWeeklyEntries ? adjustmentEntries : `₹${top250Week2PendingAmount}`}
                          </h2>
                        </div>
                      </>
                    )}


                  </div>
              </div>
            )}
          </div>
        </div>

        {unredeemedCashgrams?.length > 0 ? (
          <button
            className="cashbackBtn"
            onClick={() => navigate("/retailers/cashbacks")}
            style={{ margin: 0 }}
          >
            {t("retailer.claimCashback").toUpperCase()}
          </button>
        ) : null}

        <div className="leaderboard" style={{ marginTop: "20px" }}>
          <h2>WEEKLY LEADERBOARD</h2>
          <table>
            <thead>
              <tr>
                <th>{t("retailer.rank")}</th>
                <th>{t("retailer.entries")}</th>
                <th>{t("retailer.mobile")}</th>
              </tr>
            </thead>
            <tbody>
              {leaderboard && leaderboard?.length > 0 ? (
                leaderboard?.map((leader, i) => (
                  <tr key={leader.retailerCode || i}>
                    <td>#{leader.rank}</td>
                    <td>{(leader.weeklyEntries || 0) + (leader?.week1Adjustment || 0) + (leader?.week2Adjustment || 0)}</td>
                    <td>{maskFirstSeven(leader.mobileNumber)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="3"
                    style={{ textAlign: "center", color: "#666", fontWeight: "bold" }}
                  >
                    {t("retailer.noEntryYet")}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Adjustment Popup Modal */}
        {showAdjustmentPopup && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000
            }}
            onClick={() => setShowAdjustmentPopup(false)}
          >
            <div
              style={{
                background: 'white',
                borderRadius: '12px',
                padding: '24px',
                maxWidth: '400px',
                width: '90%',
                color: '#333',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '16px'
              }}>
                <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold' }}>
                  Pending Entries for Cashback
                </h3>
                <a
                  onClick={() => setShowAdjustmentPopup(false)}
                  style={{
                    background: 'none',
                    border: 'none',
                    fontSize: '24px',
                    cursor: 'pointer',
                    color: '#666'
                  }}
                >
                  ×
                </a>
              </div>

              <p style={{ marginBottom: '16px', lineHeight: '1.5', fontSize: '14px' }}>
                We've identified some entries from previous weeks that were missed earlier.
                These have now been included and will be added to your Week 4 and Week 5 payout.
              </p>

              <div style={{
                background: '#f5f5f5',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '12px'
              }}>
                <p style={{ fontWeight: 'bold', marginBottom: '12px', fontSize: '14px' }}>
                  Pending Adjustments:
                </p>

                {Number(week1Entries) > 0 && (
                  <div style={{ marginBottom: '12px' }}>
                    <p style={{ fontWeight: '600', marginBottom: '6px', fontSize: '13px' }}>
                      Week 1 Adjustment
                    </p>
                    <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '13px' }}>
                      <li>Entries: {week1Entries}</li>
                      <li>Amount: ₹{week1Amount}</li>
                    </ul>
                  </div>
                )}

                {Number(week2Entries) > 0 && (
                  <div style={{ marginBottom: '12px' }}>
                    <p style={{ fontWeight: '600', marginBottom: '6px', fontSize: '13px' }}>
                      Week 2 Adjustment
                    </p>
                    <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '13px' }}>
                      <li>Entries: {week2Entries}</li>
                      <li>Amount: ₹{week2Amount}</li>
                    </ul>
                  </div>
                )}

                {Number(top250Week2PendingAmount) > 0 && (
                  <div style={{ marginBottom: '12px' }}>
                    <p style={{ fontWeight: '600', marginBottom: '6px', fontSize: '13px' }}>
                      Top 250 Week 2 Pending
                    </p>
                    <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '13px' }}>
                      <li>Amount: ₹{top250Week2PendingAmount}</li>
                    </ul>
                  </div>
                )}

                <div style={{
                  borderTop: '2px solid #ddd',
                  paddingTop: '12px',
                  marginTop: '12px',
                  fontWeight: 'bold',
                  fontSize: '14px'
                }}>
                  Total Adjustment: ₹{totalAdjustmentAmount}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Language selector at bottom */}
        <div className="language-selector-bottom">
          <select
            value={i18n.language}
            onChange={(e) => changeLanguage(e.target.value)}
            className="language-dropdown-bottom"
          >
            <option value="en">English</option>
            <option value="ur">Urdu</option>
          </select>
          <div className="arrow-wrapper-bottom">
            <FaChevronDown className="dropdown-icon" fontSize={"14px"} />
          </div>
        </div>
      </div>
    </div >
  );
}
